import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '../../lib/api';

const initialState = {
  paymentMethods: [],
  selected: null,
};

export const fetchPaymentMethods = createAsyncThunk(
  'paymentMethods/fetchPaymentMethods',
  async () => {
    const response = await api.getPaymentMethods();
    return response.paymentMethods.filter((pm) => !pm.disabled);
  }
);

const paymentMethodsSlice = createSlice({
  name: 'paymentMethods',
  initialState,
  reducers: {
    selectPaymentMethod(state, action) {
      state.selected = action.payload;
    },
  },
  extraReducers: {
    [fetchPaymentMethods.fulfilled]: (state, action) => {
      //remove bank account from payment methods
      state.paymentMethods = action.payload.filter((paymentMethod) => paymentMethod.type !== 3);

      // default can be set from server
      const selectedPaymentMethod = action.payload.find((paymentMethod) => paymentMethod.selected);

      if (selectedPaymentMethod) {
        state.selected = selectedPaymentMethod.type;
      }
    },

    RESET: (state) => {
      state.selected = 1;
    },
  },
});

export const { selectPaymentMethod } = paymentMethodsSlice.actions;

export default paymentMethodsSlice.reducer;
